<template>
<v-container>
  <h1>Formulario Proveedores</h1>
  <!--FORMULARIO PROVEEDORES--->
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 

    <v-select
      v-model="t_ident"
      :items="tipo_identificacion"
      :rules="[v => !!v || 'Se requiere el tipo de identificación']"
      @change="changeTipoIdent"
      label="Tipo de Identificación"
      required
      outlined
    ></v-select>

    <v-text-field
      v-model="numero_identificacion"
      :counter="12"
      :rules="numeroIdentificacionRules"
      label="Número de Identificación"
      required
      outlined
    ></v-text-field>

    <v-select
      v-model="t_persona"
      :items="tipo_persona"
      :rules="[v => !!v || 'Se requiere el tipo de persona']"
      @change="changeTipoPersona"
      label="Tipo de Persona"
      required
      outlined
    ></v-select>

    <v-text-field
      v-model="razon_social"
      :counter="50"
      :rules="nombreRules"
      label="Nombre o Razón Social"
      required
      outlined
    ></v-text-field>

    <v-text-field
      v-model="direccion"
      :counter="30"
      :rules="direccionRules"
      label="Dirección"
      required
      outlined
    ></v-text-field>
        
    <v-select
      v-model="ciudad_option"
      :items="ciudad"
      @change="changeCiudad"
      :rules="[v => !!v || 'Se requiere el municipio']"
      label="Municipio"
      required
      outlined
    ></v-select>
        
    <v-text-field
      v-model="telefono"
      :counter="15"
      :rules="telefonoRules"
      label="Teléfono"
      type:="tel"
      required
      outlined
    ></v-text-field>
    
    <v-text-field
      v-model="email"
      :counter="20"
      :rules="emailRules"
      label="E-mail"
      required
      outlined
    ></v-text-field>

    <v-text-field
      v-model="contacto"
      :counter="30"
      :rules="contactoRules"
      label="Persona de contacto"
      required
      outlined
    ></v-text-field>
    
    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="retornar"
    >
      Inicio
    </v-btn>
    

    <v-btn 
    :disabled="!valid"
    color="warning" 
    class="mr-4" @click="registrar">   
      Registrar
    </v-btn>


    <v-btn
      color="error"
      class="mr-4"
      @click="reset"    >
      Limpiar Formulario
    </v-btn>


  </v-form>
</v-container>
</template>

<script>
import store from "../store/index.js";
  export default {
    data: () => ({
      valid: true,
      tipo_identificacion:  '',
      tipoIdentificacionRules: [
        v => !!v || 'Se requiere tipo de identificacion',
        v => (v && v.length <= 3) || 'NIT o RUT',
      ],
      numero_identificacion: '',
      numeroIdentificacionRules: [
        v => !!v || 'Se requiere número de identificación',
        v => (v && v.length <= 12) || 'Colocar sólo números sin puntos, debe ser menor o igual a 12 caracteres',
      ],
      tipo_persona: '',
      tipoPersonaRules: [
        v => !!v || 'Natural o Juridica',
        v => (v && v.length <= 8) || 'Natural o Juridica',
      ],      
      razon_social: '',
      nombreRules: [
        v => !!v || 'Se requiere Nombre o Razón Social',
        v => (v && v.length <= 50) || 'Debe ser menor o igual a 50 caracteres',
      ],
      direccion: '',
      direccionRules: [
        v => !!v || 'Se requiere dirección',
        v => (v && v.length <= 30) || 'Debe ser menor o igual a 30 caracteres',
      ],
      ciudad: '',
      municipioRules: [
        v => !!v || 'Se requiere nombre de la ciudad',
        v => (v && v.length <= 30) || 'Debe ser menor o igual a 30 caracteres',
      ],
      telefono: '',
      telefonoRules: [
        v => !!v || 'Se requiere número de teléfono',
        v => (v && v.length <= 15) || 'Solo ingrese números. Debe ser menor o igual a 15 caracteres',
      ],
      email: '',
      emailRules: [
        v => !!v || 'Se requiere un correo electrónico',
        v => /.+@.+\..+/.test(v) || 'E-mail invalido',
      ],
      contacto: '',
      contactoRules: [
        v => !!v || 'Se requiere nombre de la persona de contacto',
        v => (v && v.length <= 30) || 'Escriba el nombre de la persona de contacto, debe ser menor o igual a 30 caracteres',
      ],
      t_ident: null,
      tipo_identificacion: [
        'NIT',
        'RUT',
      ],     
      t_persona: null,
      tipo_persona: [
        'Natural',
        'Jurídica',
      ],
      ciudad_option: null,
      ciudad: [
        'Buga',
        'Cali',
        'Cartagena',
        'Porto',        
      ],
      
      
      checkbox: false,
    }),

    methods: {
      changeTipoIdent(newItem){    
        this.tipo_identificacion = newItem;
      },
      changeTipoPersona(newItem){
        this.tipo_persona=newItem;
      },
      changeCiudad(newItem){
        this.ciudad= newItem;
      },
          
      registrar(){
        if (this.$refs.form.validate()) {
          let objProveedor = {
            tipo_identificacion: this.tipo_identificacion,
            numero_identificacion: this.numero_identificacion,
            tipo_persona: this.tipo_persona,
            razon_social: this.razon_social,
            direccion: this.direccion,
            ciudad: this.ciudad,
            telefono: this.telefono,
            email: this.email,
            contacto: this.contacto,
          };
        //Crear una persona; realiza solicitud post al backend
        store.dispatch("crearProveedor", objProveedor).then(() => {
        //Limpia el formulario cuando se registra una persona
        this.$refs.form.reset();
        });
      }
    },
        retornar(){
            this.$router.push("/");
          },
        validate () {
          this.$refs.form.validate()
        },
        reset () {
          this.$refs.form.reset()
        },
        resetValidation () {
          this.$refs.form.resetValidation()
        },
    },
  };
</script>

<style>

</style>